import { Fragment } from "react";
import { PageNavbar } from "../account";
import { Container } from "@/components/container";
import { useLayout } from "@/providers";
import {
  Toolbar,
  ToolbarDescription,
  ToolbarHeading,
  ToolbarPageTitle,
} from "@/partials/toolbar";
import { MembersListing } from "./MembersListing";

const ClubMembers = () => {
  const { currentLayout } = useLayout();

  return (
    <Fragment>
      <PageNavbar />

      {currentLayout?.name === "demo1-layout" && (
        <Container>
          <Toolbar>
            <ToolbarHeading>
              <ToolbarPageTitle />
              <ToolbarDescription>
                You can manage your club members here.
              </ToolbarDescription>
            </ToolbarHeading>
          </Toolbar>
          <div className="mt-6">
            <MembersListing />
          </div>
        </Container>
      )}
    </Fragment>
  );
};

export { ClubMembers };
